<div class="position-relative">

  <mat-chip-listbox #aiChipList [multiple]="true" class="d-flex flex-wrap ai-chip-list position-relative"
    [ngClass]="{ 'ai-chip-list--no-scroll': wrap }">

    <mat-chip-option *ngFor="let title of suggested" [value]="title" [selected]="title.selected"
      (selectionChange)="updateSelectionStatus($event)" style="cursor: pointer; font-weight: 300;" [ngClass]="{
        'chip_select': title.selected,
        'ai_chip': !column,
        'w-100 d-flex font-weight-300': column
      }" [ngStyle]="{
        'margin': column ? '4px' : null,
        'gap': column ? '0.2rem' : null
      }">

      <!-- Leading icon -->
      <mat-icon *ngIf="title.selected" class="leading_icon chip_selected">check</mat-icon>
      <mat-icon *ngIf="!title.selected" class="leading_icon">add</mat-icon>

      <!-- Title -->
      {{ title.name | titlecase }}

      <!-- Count -->
      <span *ngIf="title.count && showCount">
        ({{ formatNumberToIndianFormat(title.count) }})
      </span>


      <span *ngIf="showIcons" matChipTrailingIcon class="text-9696">

        <i class="f-10 fas" [ngClass]="title.type == 'skill'
            ? 'fa-paintbrush-pencil'
            : 'fa-briefcase'">

        </i>

      </span>

    </mat-chip-option>

  </mat-chip-listbox>

  <div #faderLeft class="text-9696" (click)="scrollChipList('left')">
  </div>

  <div #faderRight class="text-9696" (click)="scrollChipList('right')">
  </div>

</div>